<div class="event-list" #eventList [ngClass]="{ 'h-100': !events.length }">
  <ng-container *ngIf="shouldPaginate; else notPaginated">
    <div class="event-card card live" *ngFor="let event of events">
      <div class="card-body" (click)="eventSelected.next(event)">
        <div class="d-flex flex-row flex-stretch">
          <ngx-landing-header [isLandingPage]="false" [event]="event"></ngx-landing-header>
        </div>
      </div>
    </div>
    <div *ngIf="!events.length" class="text-center h-100 align-content-center">No events found</div>
  </ng-container>
  <ng-template #notPaginated>
    <div class="event-card card live" *ngFor="let event of events">
      <div class="card-body" (click)="eventSelected.next(event)">
        <div class="d-flex flex-row flex-stretch">
          <ngx-landing-header [isLandingPage]="false" [event]="event"></ngx-landing-header>
        </div>
      </div>
    </div>
  </ng-template>
</div>
